import React, { ReactElement } from 'react'
import MySelect from '../../formGroup/MySelect'
import { IUploadWithRetry } from '../../../interfaces/Upload'
import { STATUS } from '../../../enums/common'
import { getOptionLabelByValue } from '../../../services/utils'
import StepFileUpload from './StepFileUpload'

function Upload({
  files,
  uploadFilesTypes,
  fileType,
  fileAlerts,
  status,
  tooltip,
  className = 'mb35',
  state,
  setState,
  validateFile,
  stateIndex,
  required,
  isMultifile,
  ...rest
}: IUploadWithRetry): ReactElement {
  const showSelect = status !== STATUS.validated
  let selectLabel = ''
  if (!showSelect) {
    selectLabel = getOptionLabelByValue(rest.options, fileType.toString())
  }
  return (
    <>
      <div className={`${showSelect ? '' : 'hidden'} ${className}`}>
        <MySelect {...rest} required={required} />
      </div>
      <div className={`${showSelect ? 'hidden' : 'inputLabel mb35 wFull'}`}>
        <span className={required ? 'inputLabelRequired' : ''}>
          {rest.label}
        </span>
        <div className="textPrimary fontSizeSm mt1 fontWeightBold opacity65">
          {selectLabel}
        </div>
      </div>
      {uploadFilesTypes[fileType] &&
        uploadFilesTypes[fileType].map((item, index) => (
          <StepFileUpload
            {...{
              index: stateIndex,
              status,
              title: item,
              tooltip,
              state,
              setState,
              validateFile,
              fileIndex: index,
              isMultifile,
            }}
            key={index}
            loadingSpinnerClassName="dFlex justifyContentEnd"
          />
        ))}
    </>
  )
}

export default Upload
